import request from '@/utils/request'

const api = {
  getBankList: 'bank/getBankList'
}

export default {
  getBankList(parameter) {
    return request({
      url: api.getBankList,
      method: 'post',
      data: parameter
    })
  }
}
